// Product Showcase Carousel with GSAP
document.addEventListener('DOMContentLoaded', function() {
  const carousel = document.querySelector('.carousel-showcase');
  if (!carousel) return;
  
  // Check if GSAP is available
  if (typeof gsap === 'undefined') {
    console.error('GSAP is required for the carousel. Please include GSAP library.');
    return;
  }
  
  const slides = carousel.querySelectorAll('.carousel-slide');
  const images = carousel.querySelectorAll('.carousel-image');
  const prevBtn = carousel.querySelector('.carousel-prev');
  const nextBtn = carousel.querySelector('.carousel-next');
  const dataScript = carousel.querySelector('.carousel-data');
  
  if (slides.length <= 1) return; // No carousel needed for single slide
  
  let currentSlide = 0;
  let isAnimating = false;
  let autoplayTimer = null;
  
  // Parse color data
  let slideData = [];
  if (dataScript) {
    try {
      slideData = JSON.parse(dataScript.textContent).slides;
    } catch (e) {
      console.warn('Could not parse carousel data:', e);
    }
  }
  
  // Settings
  const autoplay = carousel.dataset.autoplay === 'true';
  const interval = parseInt(carousel.dataset.interval) || 5000;
  
  // Helper function to convert hex to rgba
  function hexToRgba(hex, alpha) {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }
  
  // Function to create gradient strings
  function createGradientStrings(bgColor) {
    const leftGradient = `linear-gradient(
      to right,
      ${bgColor} 0%,
      ${bgColor} 20%,
      ${hexToRgba(bgColor, 0.95)} 35%,
      ${hexToRgba(bgColor, 0.8)} 50%,
      ${hexToRgba(bgColor, 0.6)} 65%,
      ${hexToRgba(bgColor, 0.4)} 75%,
      ${hexToRgba(bgColor, 0.2)} 85%,
      ${hexToRgba(bgColor, 0.05)} 95%,
      transparent 100%
    )`;
    
    const rightGradient = `linear-gradient(
      to left,
      ${bgColor} 0%,
      ${bgColor} 20%,
      ${hexToRgba(bgColor, 0.95)} 35%,
      ${hexToRgba(bgColor, 0.8)} 50%,
      ${hexToRgba(bgColor, 0.6)} 65%,
      ${hexToRgba(bgColor, 0.4)} 75%,
      ${hexToRgba(bgColor, 0.2)} 85%,
      ${hexToRgba(bgColor, 0.05)} 95%,
      transparent 100%
    )`;
    
    return { leftGradient, rightGradient };
  }
  
  // Function to animate gradients
  function animateGradients(bgColor, duration = 0.6) {
    const imageContainer = carousel.querySelector('.big-product-showcase__image');
    if (!imageContainer) return;
    
    const { leftGradient, rightGradient } = createGradientStrings(bgColor);
    
    // Create temporary elements to animate the gradients
    const beforeElement = document.createElement('div');
    const afterElement = document.createElement('div');
    
    // Style the temporary elements to match the pseudo-elements
    beforeElement.style.cssText = `
      position: absolute;
      top: 0;
      left: -80px;
      bottom: 0;
      width: 300px;
      background: ${leftGradient};
      z-index: 3;
      pointer-events: none;
      opacity: 0;
    `;
    
    afterElement.style.cssText = `
      position: absolute;
      top: 0;
      right: -80px;
      bottom: 0;
      width: 300px;
      background: ${rightGradient};
      z-index: 3;
      pointer-events: none;
      opacity: 0;
    `;
    
    // Add to DOM
    imageContainer.appendChild(beforeElement);
    imageContainer.appendChild(afterElement);
    
    // Animate in new gradients
    gsap.to([beforeElement, afterElement], {
      opacity: 1,
      duration: duration * 0.7,
      ease: "power2.inOut",
      onComplete: () => {
        // Update CSS custom properties for pseudo-elements
        carousel.style.setProperty('--showcase-bg-color', bgColor);
        
        // Remove temporary elements after a short delay
        setTimeout(() => {
          if (beforeElement.parentNode) beforeElement.remove();
          if (afterElement.parentNode) afterElement.remove();
        }, 100);
      }
    });
  }
  
  // Go to slide with GSAP animation
  function goToSlide(slideIndex, direction = 1) {
    if (isAnimating || slideIndex === currentSlide || slideIndex >= slides.length) return;
    
    isAnimating = true;
    pauseAutoplay();
    
    const currentSlideEl = slides[currentSlide];
    const currentImageEl = images[currentSlide];
    const nextSlideEl = slides[slideIndex];
    const nextImageEl = images[slideIndex];
    
    // Update colors and gradients
    if (slideData[slideIndex]) {
      const colors = slideData[slideIndex];
      
      // Animate background color
      gsap.to(carousel, {
        backgroundColor: colors.backgroundColor,
        duration: 0.6,
        ease: "power2.inOut"
      });
      
      // Animate gradients
      animateGradients(colors.backgroundColor, 0.6);
      
      // Update CSS custom properties
      carousel.style.setProperty('--showcase-text-color', colors.textColor);
      carousel.style.setProperty('--showcase-accent-color', colors.accentColor);
    }
    
    // Animation timeline
    const tl = gsap.timeline({
      onComplete: () => {
        currentSlide = slideIndex;
        isAnimating = false;
        if (autoplay) startAutoplay();
      }
    });
    
    // Animate out current content
    tl.to(currentSlideEl.querySelector('.big-product-showcase__title'), {
      opacity: 0,
      x: direction * -50,
      duration: 0.3,
      ease: "power2.inOut"
    }, 0)
    .to(currentSlideEl.querySelector('.big-product-showcase__specs'), {
      opacity: 0,
      x: direction * -60,
      duration: 0.3,
      ease: "power2.inOut"
    }, 0.05)
    .to(currentSlideEl.querySelector('.big-product-showcase__description'), {
      opacity: 0,
      x: direction * -70,
      duration: 0.3,
      ease: "power2.inOut"
    }, 0.1)
    .to(currentSlideEl.querySelector('.big-product-showcase__purchase'), {
      opacity: 0,
      x: direction * -80,
      duration: 0.3,
      ease: "power2.inOut"
    }, 0.15);
    
    // Animate out current image (including gradients)
    tl.to(currentImageEl, {
      opacity: 0,
      duration: 0.4,
      ease: "power2.inOut"
    }, 0);
    
    // Switch slides
    tl.call(() => {
      // Hide current slide
      currentSlideEl.classList.remove('active');
      currentImageEl.classList.remove('active');
      
      // Show new slide
      nextSlideEl.classList.add('active');
      nextImageEl.classList.add('active');
      
      // Set positioning - keep everything absolute
      gsap.set(nextSlideEl, { 
        position: 'absolute',
        visibility: 'visible',
        zIndex: 1
      });
      gsap.set(nextImageEl, { 
        position: 'absolute',
        visibility: 'visible',
        zIndex: 1
      });
      
      gsap.set(currentSlideEl, { 
        position: 'absolute',
        visibility: 'hidden',
        zIndex: 0
      });
      gsap.set(currentImageEl, { 
        position: 'absolute',
        visibility: 'hidden',
        zIndex: 0
      });
    }, null, 0.3);
    
    // Set initial state for new content
    tl.set(nextSlideEl.querySelector('.big-product-showcase__title'), {
      opacity: 0,
      x: direction * 50
    }, 0.3)
    .set(nextSlideEl.querySelector('.big-product-showcase__specs'), {
      opacity: 0,
      x: direction * 60
    }, 0.3)
    .set(nextSlideEl.querySelector('.big-product-showcase__description'), {
      opacity: 0,
      x: direction * 70
    }, 0.3)
    .set(nextSlideEl.querySelector('.big-product-showcase__purchase'), {
      opacity: 0,
      x: direction * 80
    }, 0.3);
    
    // Set initial state for new image (including gradients)
    tl.set(nextImageEl, {
      opacity: 0
    }, 0.3);
    
    // Animate in new content
    tl.to(nextSlideEl.querySelector('.big-product-showcase__title'), {
      opacity: 1,
      x: 0,
      duration: 0.5,
      ease: "power2.out"
    }, 0.4)
    .to(nextSlideEl.querySelector('.big-product-showcase__specs'), {
      opacity: 1,
      x: 0,
      duration: 0.5,
      ease: "power2.out"
    }, 0.45)
    .to(nextSlideEl.querySelector('.big-product-showcase__description'), {
      opacity: 1,
      x: 0,
      duration: 0.5,
      ease: "power2.out"
    }, 0.5)
    .to(nextSlideEl.querySelector('.big-product-showcase__purchase'), {
      opacity: 1,
      x: 0,
      duration: 0.5,
      ease: "power2.out"
    }, 0.55);
    
    // Animate in new image (including gradients)
    tl.to(nextImageEl, {
      opacity: 1,
      duration: 0.6,
      ease: "power2.out"
    }, 0.4);
    
    // Ensure final opacity is set correctly
    tl.set(nextSlideEl, { 
      opacity: 1 
    }, 0.9)
    .set(nextImageEl, { 
      opacity: 1 
    }, 0.9);
  }
  
  // Next slide
  function nextSlide() {
    const next = currentSlide >= slides.length - 1 ? 0 : currentSlide + 1;
    goToSlide(next, 1);
  }
  
  // Previous slide
  function prevSlide() {
    const prev = currentSlide <= 0 ? slides.length - 1 : currentSlide - 1;
    goToSlide(prev, -1);
  }
  
  // Event listeners
  if (nextBtn) {
    nextBtn.addEventListener('click', nextSlide);
  }
  
  if (prevBtn) {
    prevBtn.addEventListener('click', prevSlide);
  }
  
  // Keyboard navigation
  document.addEventListener('keydown', (e) => {
    if (!isInViewport(carousel)) return;
    
    if (e.key === 'ArrowLeft') {
      e.preventDefault();
      prevSlide();
    } else if (e.key === 'ArrowRight') {
      e.preventDefault();
      nextSlide();
    }
  });
  
  // Touch/swipe support
  let startX = 0;
  let endX = 0;
  
  carousel.addEventListener('touchstart', (e) => {
    startX = e.touches[0].clientX;
  }, { passive: true });
  
  carousel.addEventListener('touchend', (e) => {
    endX = e.changedTouches[0].clientX;
    handleSwipe();
  }, { passive: true });
  
  function handleSwipe() {
    const threshold = 50;
    const diff = startX - endX;
    
    if (Math.abs(diff) > threshold) {
      if (diff > 0) {
        // Swipe left - next slide
        nextSlide();
      } else {
        // Swipe right - previous slide
        prevSlide();
      }
    }
  }
  
  // Autoplay functions
  function startAutoplay() {
    if (autoplay && slides.length > 1) {
      autoplayTimer = setInterval(nextSlide, interval);
    }
  }
  
  function pauseAutoplay() {
    if (autoplayTimer) {
      clearInterval(autoplayTimer);
      autoplayTimer = null;
    }
  }
  
  // Helper function to check if element is in viewport
  function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }
  
  // Pause on hover
  carousel.addEventListener('mouseenter', pauseAutoplay);
  carousel.addEventListener('mouseleave', () => {
    if (autoplay) startAutoplay();
  });
  
  // Initialize first slide
  if (slides.length > 0) {
    // Set first slide as active
    slides[0].classList.add('active');
    images[0].classList.add('active');
    
    // Initialize gradients for first slide
    if (slideData[0]) {
      const firstColors = slideData[0];
      carousel.style.setProperty('--showcase-bg-color', firstColors.backgroundColor);
      carousel.style.setProperty('--showcase-text-color', firstColors.textColor);
      carousel.style.setProperty('--showcase-accent-color', firstColors.accentColor);
    }
    
    // Initialize all slides - ALL are absolutely positioned
    slides.forEach((slide, index) => {
      if (index === 0) {
        // First slide is visible but still absolute
        gsap.set(slide, { 
          opacity: 1, 
          visibility: 'visible',
          position: 'absolute',
          zIndex: 1
        });
      } else {
        // Other slides hidden
        gsap.set(slide, { 
          opacity: 0, 
          visibility: 'hidden',
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          zIndex: 1
        });
        
        // Set initial transforms for hidden slides
        if (slide.querySelector('.big-product-showcase__title')) {
          gsap.set(slide.querySelector('.big-product-showcase__title'), {
            opacity: 0,
            x: 50
          });
        }
        if (slide.querySelector('.big-product-showcase__specs')) {
          gsap.set(slide.querySelector('.big-product-showcase__specs'), {
            opacity: 0,
            x: 60
          });
        }
        if (slide.querySelector('.big-product-showcase__description')) {
          gsap.set(slide.querySelector('.big-product-showcase__description'), {
            opacity: 0,
            x: 70
          });
        }
        if (slide.querySelector('.big-product-showcase__purchase')) {
          gsap.set(slide.querySelector('.big-product-showcase__purchase'), {
            opacity: 0,
            x: 80
          });
        }
      }
    });
    
    // Initialize all images - ALL are absolutely positioned
    images.forEach((image, index) => {
      if (index === 0) {
        // First image is visible but still absolute
        gsap.set(image, { 
          opacity: 1, 
          visibility: 'visible',
          position: 'absolute',
          zIndex: 1
        });
      } else {
        // Other images hidden
        gsap.set(image, { 
          opacity: 0, 
          visibility: 'hidden',
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 0
        });
        
        // Set initial transforms for hidden images
        gsap.set(image, {
          opacity: 0
        });
      }
    });
  }
  
  // Start autoplay
  if (autoplay) {
    startAutoplay();
  }
});

// Handle Shopify theme editor
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    const carousel = event.target.querySelector('.carousel-showcase');
    if (carousel) {
      // Re-initialize carousel for theme editor
      setTimeout(() => {
        window.location.reload();
      }, 100);
    }
  });
}